import { useTheme } from "@mui/material/styles";
import { Box, Paper, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import yourServiceWorldStyle from "@/src/components/Sections/Generic/YourServiceWorld/yourServiceWorldStyle";
import Container from "@/src/components/Container/Container";
import imgYourServiceworldMobile from "@/src/assets/img/your-serviceworld/your-serviceworld-mobile.svg";
import imgYourServiceworld from "@/src/assets/img/your-serviceworld/your-serviceworld.svg";
import imgStatusMobile from "@/src/assets/img/your-serviceworld/your-serviceworld-case-status-mobile.svg";
import imgStatus from "@/src/assets/img/your-serviceworld/your-serviceworld-case-status.svg";
import { mergeSx } from "@/src/utils/mergeSx";

const YourServiceWorldCards = () => {
  const theme = useTheme();

  return (
    <Container variant={"lg"}>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper elevation={0} sx={yourServiceWorldStyle.container}>
            <ChipLegalbird label={"Ihr Fall"} sx={yourServiceWorldStyle.chip} />
            <Typography variant={"h6"} component={"h3"}>
              In wenigen Klicks Ihr rechtliches
              <br /> Anliegen schildern.
            </Typography>

            <Box sx={yourServiceWorldStyle.imageContainer}>
              <picture>
                <source media={`(min-width: ${theme.breakpoints.values.md}px)`} srcSet={imgYourServiceworld} width="431" height="284" />
                <Box component="img" src={imgYourServiceworldMobile} sx={yourServiceWorldStyle.image} width="190" height="383" />
              </picture>
            </Box>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={1}>
            <Paper elevation={0} sx={yourServiceWorldStyle.container}>
              <ChipLegalbird label={"Ihre Unterlagen"} sx={yourServiceWorldStyle.chip} />
              <Typography variant={"h6"} component={"h3"}>
                Ergänzen Sie Dokumente und Bilder zur Prüfung.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={yourServiceWorldStyle.container}>
              <ChipLegalbird label={"Professionelle Prüfung"} sx={yourServiceWorldStyle.chip} />
              <Typography variant={"h6"} component={"h3"}>
                Rechtsexperten prüfen Ihr Anliegen und
                <br /> stehen Ihnen persönlich zur Seite.
              </Typography>

              <Box sx={mergeSx(yourServiceWorldStyle.imageContainer, { marginTop: "1rem" })}>
                <picture>
                  <source media={`(min-width: ${theme.breakpoints.values.md}px)`} srcSet={imgStatus} width="676" height="268" />
                  <Box
                    component="img"
                    src={imgStatusMobile}
                    sx={mergeSx(yourServiceWorldStyle.image, {
                      width: { xs: "100%", md: "85%" },
                      display: "block",
                      margin: "0 auto",
                    })}
                    width="340"
                    height="337"
                  />
                </picture>
              </Box>
            </Paper>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default YourServiceWorldCards;
